import { Controller } from "@hotwired/stimulus";
import { apiWeb } from "@/javascripts/utils/api/wordrabbit/web";

export default class extends Controller {
  //
  // life cycle
  //
  // initialize() {
  // }

  //
  // target
  //
  static targets = ["list", "btn", "body", "latestData"];

  //
  // methods
  //
  async readMore() {
    const $this = $(this.targets.element);
    const blogId = $this.data("blog-id");
    const lastBlogId = this.lastBlogId();
    const { data } = await apiWeb.get(`/blog/more?blog_id=${blogId}&last_blog_id=${lastBlogId}`);
    if (data) {
      $(this.bodyTarget).append(data);
      this.isReadMoreAvailable();
    } else {
      // バックエンドのエラーで読み込めなかった場合はボタンを非表示にする
      $(this.btnTarget).addClass("hidden");
    }
  }

  // private
  lastBlogId() {
    const $listTargets = $(this.listTargets);
    const $lastTarget = $($listTargets[$listTargets.length - 1]);
    return $lastTarget.data("id");
  }

  isReadMoreAvailable() {
    const $latestDataTargets = $(this.latestDataTargets);
    const $latestData = $($latestDataTargets[$latestDataTargets.length - 1]);
    if ($latestData.data("is-more-available")) {
      $(this.btnTarget).removeClass("hidden");
    } else {
      $(this.btnTarget).addClass("hidden");
    }
  }
}
